import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Span } from 'components/styles_components/container';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'components/ui';

const Confimation = ({ title, description, onClick, children, disabled }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    !disabled && setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Span onClick={handleClickOpen}>{children}</Span>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              onClick();
              handleClose();
            }}
            autoFocus
          >
            <FormattedMessage id="button.confirm" />
          </Button>
          <Button variant="outlined" onClick={handleClose}>
            <FormattedMessage id="button.cancel" />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Confimation;
